import { MicroContentMedia } from 'components/MicroContent';
import Text from 'components/Text';
import type { InspirationLink } from 'models/sitecore';
import { getAsset } from 'utils/helpers';

interface Props {
	className?: string;
	heading: string;
	inspirationLink: InspirationLink | undefined;
}

export default function PageHeaderInspirationMedia({
	className,
	heading,
	inspirationLink,
}: Props) {
	const image = getAsset(
		'Templated 2:1',
		inspirationLink?.fields?.landscapeImage,
	);
	const linkText = inspirationLink?.fields?.navigationTitle?.value;

	if (!image?.src || !linkText) {
		return null;
	}

	return (
		<div className={className}>
			<Text as="h3" className="mb-4 sm:mb-6">
				{heading}
			</Text>
			<MicroContentMedia
				href={inspirationLink.href}
				text={linkText}
				imgSrc={image.src}
				imgWidth={345}
				imgHeight={172}
			/>
		</div>
	);
}
PageHeaderInspirationMedia.displayName = 'PageHeaderInspirationMedia';
